import React from 'react';
import { useLocation, Link as RrdLink } from 'react-router-dom';
import PropTypes from 'prop-types';

const Link = ({ to, search, hash, ...props }) => {
  const location = useLocation();
  return (
    <RrdLink
      {...props}
      // auto append the previous location to history.pathname.state.from
      to={{
        pathname: to,
        search,
        hash,
        state: { from: location.pathname, hash: location.hash },
      }}
    />
  );
};

Link.propTypes = {
  to: PropTypes.string.isRequired,
  search: PropTypes.string,
};

export default Link;
